import { render, staticRenderFns } from "./VButton.vue?vue&type=template&id=10a68280&scoped=true"
import script from "./VButton.vue?vue&type=script&lang=js"
export * from "./VButton.vue?vue&type=script&lang=js"
import style0 from "./VButton.vue?vue&type=style&index=0&id=10a68280&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a68280",
  null
  
)

export default component.exports